var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "pb-0" },
        [
          _c("GroupModal", {
            attrs: { id: "groupModal", create: true },
            scopedSlots: _vm._u([
              {
                key: "clickable",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "mb-2",
                            attrs: {
                              color: "primary",
                              "data-cy": "createNewGroupBtn",
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v(" Create New Group ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-0",
        attrs: {
          headers: _vm.groupsHeaders,
          items: _vm.groupData,
          dense: "",
          loading: _vm.loading,
          search: _vm.search,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "top",
              fn: function () {
                return [
                  _c(
                    "v-container",
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Search",
                          "single-line": "",
                          dense: "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: `item.members`,
              fn: function ({ item }) {
                return [
                  _vm._l(item.members.slice(0, 3), function (user) {
                    return _c(
                      "span",
                      { key: user.id },
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "ma-1",
                            attrs: { pill: "", color: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.displayUsersDialog(item.members)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.getMemberName(user)) + " ")]
                        ),
                      ],
                      1
                    )
                  }),
                  item.members.length > 3
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "ma-1",
                          attrs: { pill: "", color: "primary", outlined: "" },
                          on: {
                            click: function ($event) {
                              return _vm.displayUsersDialog(item.members)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(`+${item.members.length - 3} more`) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
            },
            {
              key: `item.owners`,
              fn: function ({ item }) {
                return [
                  _vm._l(item.owners.slice(0, 3), function (user) {
                    return _c(
                      "span",
                      { key: user.id },
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "ma-1",
                            attrs: { pill: "", color: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.displayUsersDialog(item.owners)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.getMemberName(user)) + " ")]
                        ),
                      ],
                      1
                    )
                  }),
                  item.owners.length > 3
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "ma-1",
                          attrs: { pill: "", color: "primary", outlined: "" },
                          on: {
                            click: function ($event) {
                              return _vm.displayUsersDialog(item.owners)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(`+${item.owners.length - 3} more`) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
            },
            {
              key: `item.actions`,
              fn: function ({ item }) {
                return [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { color: "secondary", left: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        small: "",
                                        title: "Info",
                                        "data-cy": "info",
                                      },
                                    },
                                    on
                                  ),
                                  [_vm._v(" mdi-information ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "v-card",
                        {
                          attrs: {
                            color: "transparent",
                            flat: "",
                            "max-width": "600px",
                            "overflow-y-auto": "",
                          },
                        },
                        [
                          _c(
                            "span",
                            [
                              _c("v-card-title", [_vm._v(_vm._s(item.name))]),
                              _c("v-card-text", [
                                _c("div", [
                                  _vm._v(
                                    "Visibility: " +
                                      _vm._s(item.public ? "Public" : "Private")
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "Created At: " + _vm._s(item.createdAt)
                                  ),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "Updated At: " + _vm._s(item.updatedAt)
                                  ),
                                ]),
                              ]),
                              _c("v-card-subtitle", [
                                _c("strong", [_vm._v("Group Description")]),
                              ]),
                              item.desc !== ""
                                ? _c(
                                    "v-card-text",
                                    _vm._l(
                                      item.desc.split("\n"),
                                      function (line, index) {
                                        return _c("div", { key: index }, [
                                          _vm._v(" " + _vm._s(line) + " "),
                                          _c("br"),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _c("v-card-text", [_vm._v("None")]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  item.role === "owner" || _vm.adminPanel
                    ? _c(
                        "span",
                        [
                          _c("GroupModal", {
                            attrs: {
                              id: "editGroupModal",
                              create: false,
                              admin: _vm.adminPanel,
                              group: item,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "clickable",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              small: "",
                                              title: "Edit",
                                              "data-cy": "edit",
                                            },
                                          },
                                          on
                                        ),
                                        [_vm._v(" mdi-pencil ")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                title: "Delete",
                                "data-cy": "delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteGroupDialog(item)
                                },
                              },
                            },
                            [_vm._v(" mdi-delete ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
            {
              key: "no-data",
              fn: function () {
                return [_vm._v(" No groups match current selection. ")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c("ActionDialog", {
        attrs: { type: "group" },
        on: { cancel: _vm.closeActionDialog, confirm: _vm.deleteGroupConfirm },
        model: {
          value: _vm.dialogDelete,
          callback: function ($$v) {
            _vm.dialogDelete = $$v
          },
          expression: "dialogDelete",
        },
      }),
      _c("GroupUsers", {
        attrs: { "dialog-display-users": _vm.dialogDisplayUsers },
        on: {
          "close-group-users-dialog": function ($event) {
            _vm.dialogDisplayUsers = false
          },
        },
        model: {
          value: _vm.selectedGroupUsers,
          callback: function ($$v) {
            _vm.selectedGroupUsers = $$v
          },
          expression: "selectedGroupUsers",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }